import React from "react";
import ReactDOM from "react-dom";
import "./polyfills";
import "./index.css";
import App from "./App";
import { Route, Switch, Link, NavLink } from "react-router-dom";

Route.displayName = "Route";
Switch.displayName = "Switch";
Link.displayName = "Link";
NavLink.displayName = "NavLink";

ReactDOM.render(<App />, document.getElementById("root"));
